// src/hooks/useGeneratePdfOnce.js
import { useEffect, useRef } from "react";

/**
 * Ejecuta generateFn UNA sola vez cuando `condition` sea true.
 * Aunque el componente padre re-renderice, no se vuelve a llamar.
 */
export function useGeneratePdfOnce(condition, generateFn) {
  const hasGeneratedRef = useRef(false);

  useEffect(() => {
    if (!condition) return;
    if (hasGeneratedRef.current) return;

    hasGeneratedRef.current = true;
    generateFn();
  }, [condition, generateFn]);
}
